export const getPositionFromLocale = (locale, locales) => {
    if (typeof locales !== 'undefined') {
        return locales.indexOf(locale);
    } else {
        return 0;
    }
};